import React from 'react';
import { Box, Typography } from '@mui/material';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

interface Props {
  multiple: boolean;
  disabled?: boolean;
  isDragging?: boolean;
  onClick?: () => void;
  onDragOver?: (e: React.DragEvent) => void;
  onDragLeave?: (e: React.DragEvent) => void;
  onDrop?: (e: React.DragEvent) => void;
}

export default function WaiverImageDropzone({
  multiple,
  disabled = false,
  isDragging = false,
  onClick,
  onDragOver,
  onDragLeave,
  onDrop,
}: Props) {
  return (
    <Box
      onClick={disabled ? undefined : onClick}
      onDragOver={disabled ? undefined : onDragOver}
      onDragLeave={disabled ? undefined : onDragLeave}
      onDrop={disabled ? undefined : onDrop}
      sx={theme => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.75,
        px: 3,
        py: 3,
        borderRadius: 1.5,
        border: '1.5px dashed',
        borderColor: isDragging
          ? theme.palette.primary.main
          : theme.palette.outlineGrey.main,
        backgroundColor: isDragging
          ? `${theme.palette.primary.main}0f`
          : 'transparent',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        userSelect: disabled ? 'none' : undefined,
        transition: 'border-color 0.15s, background-color 0.15s',
        ...(!disabled && {
          ':hover': {
            borderColor: theme.palette.primary.main,
            backgroundColor: `${theme.palette.primary.main}08`,
            '& .dropzone-icon': { color: theme.palette.primary.main },
          },
        }),
      })}>
      <AddPhotoAlternateIcon
        className="dropzone-icon"
        sx={theme => ({
          fontSize: 28,
          color: isDragging ? theme.palette.primary.main : 'text.primary',
          transition: 'color 0.15s',
        })}
      />
      <Typography
        variant="subtitle2"
        sx={theme => ({
          color: isDragging ? theme.palette.primary.main : 'text.primary',
          textAlign: 'center',
        })}>
        {isDragging ? 'Drop to upload' : 'Choose a file or drag & drop it here'}
      </Typography>
      <Typography
        variant="caption"
        sx={() => ({
          color: 'text.primary',
          textAlign: 'center',
        })}>
        {multiple ? 'Multiple files allowed · ' : ''}JPG, PNG, WebP, HEIC
        supported
      </Typography>
    </Box>
  );
}
